export default "__VITE_ASSET__CIFLtgAN__"